module.exports = __webpack_public_path__ + "static/1-b8544447a9668dc353df6c4707b7d96f.jpg";